module.exports = __webpack_public_path__ + "img/Frech.2c45be57.svg";